<template>
  <div>
    <div v-if="action === 'create' || action === 'edit'" class="modal fade" :id="modalId" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <template v-if="action === 'create'">
              <h4 class="modal-title">Add new Document</h4>
            </template>
            <template v-else>
              <h4 class="modal-title" v-if="document">Edit Document : {{document.title}}</h4>
            </template>
          </div>
          <form v-on:submit="addDocument" action="#" method="post">
            <div class="modal-body">
              <div class="row">
                <div class="col-xs-8">
                  <div class="form-group">
                    <label class="control-label" for="doi">DOI</label>
                    <input v-model="doi" type="text" placeholder="Document DOI"
                           title="" value="" name="doi" id="doi"
                           class="form-control">
                    <span v-if="errorDoi" class="help-block text-danger">{{this.errorDoi}}</span>
                  </div>
                </div>
                <div class="col-xs-4 m-t-md text-center">
                  <vue-ladda v-if="action === 'create'" type="submit" :loading="btnFindDocument.loading" class="btn btn-info" v-on:click="findDocumentByDoi" :data-style="btnFindDocument.dataStyle">Find Document by  DOI</vue-ladda>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label class="control-label required" for="title">Title</label>
                    <input v-model="title" type="text" placeholder="Document Title"
                           title="" value="" name="title" id="title" :disabled="findDocument"
                           class="form-control">
                    <span v-if="errorTitle" class="help-block text-danger">{{this.errorTitle}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 m-t" >
                  <div class="form-group">
                    <label class="required">Authors</label>
                    <span class="help-block m-b m-t-none">
                        Enter the authors in the same order as in the publication </span>
                    <div  v-for="(author, key) in authors" v-bind:key="key" >
                      <Authors  :author="author"  :removeAuthor="removeAuthor" :index="key" :disabled="findDocument" />
                    </div>
                    <div class="text-center" style="margin-top: 10px" v-if="!findDocument">
                      <button class="btn btn-sm btn-outline btn-primary" v-on:click="addAuthor" ><i class="fa fa-plus"></i>Add Author</button>
                    </div>
                    <span v-if="errorAuthors" class="help-block text-danger">{{this.errorAuthors}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label class="control-label required" for="abstract">Abstract</label>
                    <textarea v-model="abstract" title=""
                              placeholder="Document abstract..." name="abstract"
                              id="abstract" class="form-control" cols="4" rows="4" maxlength="3000" :disabled="findDocument"></textarea>
                    <span class="help-block m-b-none col-xs-9">The abstract must not exceed 3000 characters</span>
                    <span class="help-block m-b-none text-right col-xs-3" v-if="abstract">{{abstract.length}} Characters</span>
                    <span v-if="errorAbstract" class="help-block text-danger">{{this.errorAbstract}}</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label class="control-label required" for="link">Link</label>
                    <input v-model="link" type="text" placeholder="Document link"
                           title="" value="" name="link" id="link" :disabled="findDocument"
                           class="form-control">
                    <span v-if="errorLink" class="help-block text-danger">{{this.errorLink}}</span>
                  </div>
                </div>
                <div class="col-xs-12 m-t">
                  <div class="form-group">
                    <label class="control-label required" for="published_date">Published Date</label>
                    <date-picker id="published_date" v-model="publishedDate" :config="configDate"  placeholder="Published Date (2010-05-20)"
                                 class="form-control" :disabled="findDocument"/>
                    <span v-if="errorDatePublished" class="help-block text-danger">{{this.errorDatePublished}}</span>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="form-group">
                    <label class="control-label required" for="link">Source</label>
                    <input v-model="source" type="text" placeholder="Document source"
                           title="" value="" name="source" id="source" :disabled="findDocument"
                           class="form-control">
                  </div>
                </div>
              </div>

              <div style="text-align: right;margin-top: 10px">
                <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="onCancel">Cancel</button>
              <vue-ladda v-if="action === 'create'" type="submit" :loading="submitDocument.loading" class="btn btn-info" :data-style="submitDocument.dataStyle">
                Add <template v-if="!findDocument">new</template> document
              </vue-ladda>
              <vue-ladda v-if="action === 'edit'" type="submit" :loading="submitDocument.loading" class="btn btn-info" :data-style="submitDocument.dataStyle">Save changes</vue-ladda>

            </div>
          </form>

        </div>
      </div>

    </div>
  </div>

</template>

<script>
import VueLadda from 'vue-ladda'
import Authors from '../../components/user/Authors'
import DatePicker from 'vue-bootstrap-datetimepicker'

export default {
  components: {
    VueLadda,
    Authors,
    DatePicker
  },
  props: ['value', 'refresh', 'user'],
  name: 'ActionModalDocument',
  watch: {
    modalId: function () {
      this.init()
    }
  },
  methods: {
    addDocument: function (event) {
      event.preventDefault()

      this.submitDocument.loading = true

      this.axios.post('/user/' + this.user.id + '/document/' + (this.document !== null ? this.document.id : ''), {
        title: this.title,
        abstract: this.abstract,
        authors: this.authors,
        doi: this.doi,
        link: this.link,
        source: this.source,
        date_published: this.publishedDate
      }).then((response) => {
        if (typeof this.refresh !== 'undefined') {
          this.refresh(response.data)
        }

        this.$eventHub.$emit('refreshUserDocumentsList', true)
        $('#' + this.modalId + '').modal('toggle')
        this.title = null
        this.abstract = null
        this.doi = null
        this.link = null
        this.source = null
        this.authors = null

        this.errorTitle = null
        this.errorLink = null
        this.errorDoi = null
        this.errorAbstract = null
        this.errorAuthors = null
        this.errorDatePublished = null
        this.$notify({
          type: 'success',
          title: 'Waiting validation',
          content: 'We will check information, and accept it soon',
          placement: 'bottom-right'
        })
      })
        .catch((error) => {
          if (error.response.status === 400) {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorTitle = errors['title'][0]
                break
              case 2:
                this.errorAbstract = errors['abstract'][0]
                break
              case 3:
                this.errorAuthors = errors['authors'][0]
                break
              case 4:
                this.errorDatePublished = errors['date_published'][0]
                break
            }
          }
        })
        .finally(() => {
          this.submitDocument.loading = false
        })
    },
    findDocumentByDoi: function (event) {
      event.preventDefault()
      this.document = null
      this.findDocument = false
      this.init()
      if (!this.doi) {
        this.errorDoi = 'Please fill DOI mandatory field ...'
      } else {
        this.btnFindDocument.loading = true
        this.errorDoi = null
        let param = encodeURIComponent(this.doi)

        this.axios.get('/search/doi/' + encodeURI(param)).then((response) => {
          if (response.data && response.data.length !== 0) {
            this.document = response.data[0]
            this.findDocument = true
            this.init()
            this.errorDoi = null
          } else {
            this.errorDoi = 'Sorry document not found! Please fill the fields below... '
          }
          this.errorTitle = null
          this.errorLink = null
          this.errorAbstract = null
          this.errorAuthors = null
          this.errorDatePublished = null
        })
          .catch((error) => {
            if (error.response.status === 400) {
              this.errorDoi = error.response.data.errors
            }
            this.errorDoi = 'Sorry document not found! Please fill the fields below... '
          })
          .finally(() => {
            this.btnFindDocument.loading = false
          })
      }
    },
    addAuthor: function (event) {
      event.preventDefault()
      this.authors.push({
        first_name: null,
        last_name: null,
        orcid: null,
        affiliations: []
      })
    },
    removeAuthor: function (event, index) {
      event.preventDefault()
      this.authors.splice(index, 1)
    },
    init: function () {
      this.action = this.value

      switch (this.action) {
        case 'create' :
          this.modalId = 'addDocument'
          break
        case 'edit' :
          this.modalId = 'editDocument-' + this.document.id
          break
        case 'delete' :
          this.modalId = 'deleteDocument-' + this.document.id
          break
      }

      if (this.document !== null) {
        this.title = this.document.title
        this.doi = this.document.doi
        this.authors = this.document.authors
        this.link = this.document.link
        this.abstract = this.document.abstract
        this.publishedDate = this.document.date
        this.source = this.document.publication
      } else {
        this.title = null
        this.authors = []
        this.link = null
        this.abstract = null
        this.publishedDate = null
      }
    },
    onCancel: function () {
    },
    showModal: function () {
      $('#' + this.modalId).modal()
      $('#' + this.modalId).on('hidden.bs.modal', (e) => {
        this.$emit('input', null)
      })
    }
  },
  data () {
    return {
      document: null,
      action: null,
      name: null,
      doi: null,
      title: null,
      link: null,
      source: null,
      authors: [],
      publishedDate: null,
      abstract: null,
      findDocument: false,
      errorTitle: null,
      errorLink: null,
      errorDoi: null,
      errorAbstract: null,
      errorAuthors: null,
      errorDatePublished: null,
      configDate: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      },
      submitDocument: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      btnFindDocument: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      modalId: null
    }
  },
  mounted () {
    this.showModal()
  },
  beforeMount () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/ActionModalDocument.vue